import { render } from "./FmAudio.vue?vue&type=template&id=1fa13713&scoped=true&ts=true"
import script from "./FmAudio.vue?vue&type=script&lang=ts"
export * from "./FmAudio.vue?vue&type=script&lang=ts"

import "./FmAudio.vue?vue&type=style&index=0&id=1fa13713&lang=less&scoped=true"

import exportComponent from "D:\\waibao\\lsjy-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa13713"]])

export default __exports__